module.exports = __webpack_public_path__ + "img/父母课堂@2x.a50b37b6.png";